import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { JobbDTO } from "./jobb.models";

@Injectable({
    providedIn: "root"
})
export class JobbService {
    currentjobb$: BehaviorSubject<JobbDTO[]>;

    private readonly apiClient = inject(ApiClientService);
    private readonly autoRefreshActiveInternal$ = new BehaviorSubject<boolean>(false);

    constructor() {
        this.currentjobb$ = new BehaviorSubject<JobbDTO[]>([]);
    }

    get autoRefreshActive$(): Observable<boolean> {
        return this.autoRefreshActiveInternal$.asObservable();
    }

    refreshJobb(): Observable<JobbDTO[]> {
        return this.apiClient.get<JobbDTO[]>("administration/modifyjobb/GetJobbForAdminPage", false).pipe(
            tap(x => this.currentjobb$.next(x))
        );
    }

    toggleAutoRefresh(active: boolean): void {
        this.autoRefreshActiveInternal$.next(active);
    }
}
